import { defineMessages } from '@/hooks/useTranslation';

export default defineMessages({
  meta: {
    title: {
      de: 'Shopware Shop programmieren lassen | Professionelle Shopware Agentur',
      en: 'Get your Shopware Shop developed | Professional Shopware Agency'
    },
    description: {
      de: 'Shop programmieren lassen von Experten ✓ Über 10 Jahre Shopware-Erfahrung ✓ B2B & B2C Shops ✓ Individuelle Entwicklung ✓ Jetzt kostenlos beraten lassen',
      en: 'Get your shop developed by experts ✓ Over 10 years of Shopware experience ✓ B2B & B2C shops ✓ Individual development ✓ Get free consultation now'
    }
  },
  hero: {
    title: {
      de: 'Shopware Shop programmieren lassen',
      en: 'Get your Shopware shop developed'
    },
    subtitle: {
      de: 'Professionelle E-Commerce Lösungen mit Shopware 6',
      en: 'Professional E-Commerce solutions with Shopware 6'
    },
    description: {
      de: 'Als zertifizierter Shopware Business Partner entwickeln wir maßgeschneiderte Online-Shops für B2B und B2C. Mit über 10 Jahren Erfahrung setzen wir Ihr E-Commerce Projekt professionell und zuverlässig um.',
      en: 'As a certified Shopware Business Partner, we develop customized online shops for B2B and B2C. With over 10 years of experience, we implement your e-commerce project professionally and reliably.'
    },
    cta: {
      de: 'Kostenlose Beratung anfragen',
      en: 'Request free consultation'
    }
  },
  features: {
    title: {
      de: 'Warum Shopware für Ihren Online-Shop?',
      en: 'Why Shopware for your online shop?'
    },
    description: {
      de: 'Shopware bietet zahlreiche Vorteile für moderne E-Commerce Anforderungen',
      en: 'Shopware offers numerous advantages for modern e-commerce requirements'
    }
  },
  competence: {
    title: {
      de: 'Unsere Shopware Kompetenz',
      en: 'Our Shopware expertise'
    },
    description: {
      de: 'Als zertifizierter Shopware Business Partner bieten wir das komplette Leistungsspektrum',
      en: 'As a certified Shopware Business Partner, we offer the complete range of services'
    }
  },
  process: {
    title: {
      de: 'Unser Shopware Entwicklungsprozess',
      en: 'Our Shopware development process'
    },
    description: {
      de: 'Transparente und effiziente Umsetzung Ihres Shopware Projekts',
      en: 'Transparent and efficient implementation of your Shopware project'
    }
  },
  testimonials: {
    title: {
      de: 'Was unsere Kunden sagen',
      en: 'What our customers say'
    },
    description: {
      de: 'Erfahrungen zufriedener Shopware Kunden',
      en: 'Experiences of satisfied Shopware customers'
    }
  },
  cta: {
    title: {
      de: 'Bereit für Ihren erfolgreichen Shopware Shop?',
      en: 'Ready for your successful Shopware shop?'
    },
    description: {
      de: 'Kontaktieren Sie uns für eine kostenlose Erstberatung zu Ihrem E-Commerce Projekt',
      en: 'Contact us for a free initial consultation on your e-commerce project'
    },
    button: {
      de: 'Jetzt Beratungstermin vereinbaren',
      en: 'Schedule a consultation now'
    }
  },
  banner: {
    title: {
      de: 'Shopware Agentur',
      en: 'Shopware Agency'
    },
    subtitle: {
      de: 'Zertifizierter Shopware Business Partner',
      en: 'Certified Shopware Business Partner'
    }
  }
}); 